module.exports = __webpack_public_path__ + "img/experian.214ca3da.svg";